// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"874dffe8","455":"c1b59e38","977":"bf22878a"}[chunkId] + ".chunk.js";
};